<template>
    <div>
        <div class="Index-head-bigDiv">
            <el-card class="box-card"
                     style="width: 100%;height: 450px">
                <el-row>
                    <el-col :span="12">
                        <el-divider content-position="left" class="cursor"><span style="font-size: 22px">公司简介</span>
                        </el-divider>

                    </el-col>
                    <el-col :span="7">
                        <el-divider content-position="right" class="cursor">
                          <span @mouseover="Mouseover('certificate')" id="certificate" class="mouseoverShow cursor">
                                {{valuesList1name1}}
                             </span>
                        </el-divider>
                    </el-col>
                    <el-col :span="5">
                        <el-divider content-position="right" class="cursor">
                           <span @mouseover="Mouseover('dynamic')" id="dynamic" class="mouseoverShow cursor">
                                {{valuesList1name2}}
                        </span>
                        </el-divider>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="7">
                        <div class="slideDiv" @click="IntroduceClick">
                            <img class="slideImg" :src="BasePath + introduce.newsIamges" width="100%" height="360px"/>
                        </div>
                    </el-col>
                    <el-col :span="9" class="cursor">
                        <div v-html="introduce.newsContent" style="width: 90%;margin-left: 5%;white-space: pre-wrap;"
                             @click="IntroduceClick"></div>
                    </el-col>
                    <el-col :span="8">
                        <el-card v-if="mouseoverShow.certificate" class="box-card"
                                 style="width: 100%;">
                            <el-divider content-position="left">
                                {{valuesList1name1}}<span style="color: darkgray;margin-left: 10px">/ Notice</span>
                            </el-divider>
                            <div style="height: 270px;">
                                <ul style="margin: 0">
                                    <li v-for="(item,index) in certificateText" :key="index"
                                        class="cursor certificateLi" @click="CertificateClik(item)">
                                        {{item.newsTitle}}
                                    </li>
                                </ul>
                            </div>
                        </el-card>
                        <el-card v-if="mouseoverShow.dynamic" class="box-card"
                                 style="width: 100%;">
                            <el-divider content-position="left">
                                {{valuesList1name2}}<span style="color: darkgray;margin-left: 10px">/ Notice</span>
                            </el-divider>
                            <div style="height: 270px;">
                                <ul style="margin: 0">
                                    <li v-for="(item,index) in dynamicText" :key="index" class="cursor certificateLi"
                                        @click="DynamicClick(item)">
                                        {{item.newsTitle}}
                                    </li>
                                </ul>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>
            <el-row style="margin-top: 20px">
                <el-col :span="12" v-for="(item,index) in cultureImg" :key="index">
                    <div :class="'culture-'+((index / 2 % 2) < 1 ? 'top' : 'bottom')">
                        <el-row>
                            <el-col :span="12">
                                <div class="slideDiv culture" @click="CultureClick(item)">
                                    <img class="slideImg" v-if="(((index / 2 % 2) < 1 ? 'top' : 'bottom')) === 'bottom'"
                                         :src="BasePath + item.newsIamges" width="100%"
                                         height="200px">
                                    <div v-if="(((index / 2 % 2) < 1 ? 'top' : 'bottom')) === 'top'"
                                         class="culture-left cursor">
                                        <div style="font-size: 20px;margin-top: 40px">{{item.catalogName}}</div>
                                        <div>{{item.contentdesc}}</div>
                                        <div class="culture-arrow1">
                                            <img src="static/culture/arrow1.png">
                                        </div>
                                        <div class="culture-arrow2">
                                            <img src="static/culture/arrow2.png">
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="slideDiv culture" @click="CultureClick(item)">
                                    <div v-if="(((index / 2 % 2) < 1 ? 'top' : 'bottom')) === 'bottom'"
                                         class="culture-right cursor">
                                        <div style="font-size: 20px;margin-top: 40px">{{item.catalogName}}</div>
                                        <div>{{item.contentdesc}}</div>
                                        <div class="culture-arrow1">
                                            <img src="static/culture/arrow1.png">
                                        </div>
                                        <div class="culture-arrow2">
                                            <img src="static/culture/arrow2.png">
                                        </div>
                                    </div>
                                    <img class="slideImg" v-if="(((index / 2 % 2) < 1 ? 'top' : 'bottom')) === 'top'"
                                         :src="BasePath + item.newsIamges" width="100%"
                                         height="200px">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <div style="width: 100%;text-align: center;margin-top: 40px">
                <img src="static/index/product.jpg" width="100%" height="200"/>
                <div style="margin-top: -190px">
                    <div style="color: white;font-size: 30px;letter-spacing:5px">{{valuesList1name3}}</div>
                    <span style="color: white">_________________</span>
                </div>
                <div style="margin-top: 40px;">
                    <el-carousel :interval="5000" height="320px">
                        <el-carousel-item v-for="item in (Math.ceil(engineeringCase.length / 3))" :key="item"
                                          style="width: 100%">
                            <el-row>
                                <el-col :span="8" v-for="index in 3" :key="index"
                                        v-if="engineeringCase[((item - 1) * 3) + index - 1]" class="engineeringCaseCol">
                                    <div @click="EngineeringCaseClick(engineeringCase[((item - 1) * 3) + index - 1])">
                                        <div class="slideDiv" style="width:90%;height: 300px;margin-left: 5%">
                                            <img class="slideImg"
                                                 :src="BasePath + engineeringCase[((item - 1) * 3) + index - 1].newsIamges"
                                                 width="100%" height="100%">
                                        </div>
                                        <div class="engineeringCaseDiv cursor">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    {{engineeringCase[((item - 1) * 3) + index - 1].newsTitle}}
                                                </div>
                                                <el-button style="width: 100%;background: none;border: none;color: white;
                                                padding: 0px 8px; text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                    {{engineeringCase[((item - 1) * 3) + index - 1].newsTitle}}
                                                </el-button>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div style="text-align: center;width: 100%;height: 110px;background: rgb(219,219,219);margin-top: 20px">
                <h2 class="cursor" style="margin-top: 20px;float: left;width: 100%">固基行远,协晨悟通</h2>
                <div class="bottom">
                    <span class="bottom-span cursor">技术支持：固远晨通科技发展有限公司</span>
                </div>
                <div class="bottom">
                    <span class="bottom-span cursor">邮箱：GuYuanChenTong@126.com</span>
                </div>
                <div class="bottom">
                    <span class="bottom-span cursor">ICP备案号：蜀ICP备16018349号-3</span>
                </div>
                <div class="bottom">
                    <span class="bottom-span cursor"><a target="_blank" href="http://www.kuaidi.com/">快递查询API</a></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                valuesList1name1: "",
                valuesList1name2: "",
                valuesList1name3: "",
                mouseoverShow: {
                    // 专业证书
                    certificate: true,
                    // 企业动态
                    dynamic: false,
                },
                // 专利
                certificateText: [],
                // 动态
                dynamicText: [],
                // 项目
                engineeringCase: [],
                // 模块
                cultureImg: [],
                // 简介信息
                introduce: {},
                loadding: null
            }
        },
        async created() {
            this.loadding = this.openLoading();
            await this.$http.get('Home/IndexData').then(res => {
                this.introduce = res.data.valuesListLis[0][0];
                this.introduce.newsContent = res.data.valuesListnamecontent;
                this.certificateText = res.data.valuesListLis[1];
                this.dynamicText = res.data.valuesListLis[2];
                this.engineeringCase = res.data.valuesListLis[3];
                this.valuesList1name1 = res.data.valuesList1name1;
                this.valuesList1name2 = res.data.valuesList1name2;
                this.valuesList1name3 = res.data.valuesList1name3;
                this.cultureImg = res.data.mainbusinessLis;
            }).catch(() => {
                this.$message.error('服务器异常,请联系管理员!')
            })
        },
        updated() {
            if(this.loadding){
                this.loadding.close();
            }
        },
        methods: {
            Mouseover(key) {
                for (var k in this.mouseoverShow) {
                    this.mouseoverShow[k] = false;
                    document.getElementById(k).style.color = "black";
                    document.getElementById(k).style.borderBottom = "none";
                }
                this.mouseoverShow[key] = true;
                document.getElementById(key).style.color = "#1961AC";
                document.getElementById(key).style.borderBottom = "#1961AC 1px solid";
            },
            // 点击简介
            IntroduceClick() {
                this.$router.push({path: "/Introduce", query: {catalogId: this.introduce.catalogId, id: null}})
                location.reload();
            },
            // 点击专利
            CertificateClik(item) {
                this.$router.push({path: "/Introduce", query: {catalogId: item.catalogId, id: item.id}})
                location.reload();
            },
            // 点击企业动态
            DynamicClick(item) {
                this.$router.push({path: "/Introduce", query: {catalogId: item.catalogId, id: item.id}})
                location.reload();
            },
            // 点击模块
            CultureClick(item) {
                this.$router.push({path: "/Introduce", query: {catalogId: item.id, id: null}})
                location.reload();
            },
            // 点击病害整治管理案例
            EngineeringCaseClick(item) {
                this.$router.push({path: "/Introduce", query: {catalogId: item.catalogId, id: item.id}})
                location.reload();
            },
        },
    }
</script>

<style scoped>
    #head {

    }

    .head-img {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        float: left;
        height: 800px;
    }

    .head-bigDiv {
        width: 70%;
        margin-left: 15%;
        height: 690px;
        background-color: white;
        z-index: 2;
        padding: 20px;
        margin-top: -620px;
        float: left;
    }

    .head-bigDiv-logo {
        margin: 20px;
    }

    .head-bigDiv-hoverDiv {
        width: 80px;
        height: 2px;
        background: #1C6894;
        display: none;
    }

    .head-bigDiv-hover:hover .head-bigDiv-hoverDiv {
        display: inline-block !important;
    }

    .head-bigDiv-hover:hover .head-bigDiv-hoverSpan {
        margin-top: -20px !important;
    }

    .head-bigDiv-dropdown-menu {
        border-bottom: 1px solid;
        border-color: antiquewhite !important;
        width: 80%;
        margin-top: 10px;
        padding-bottom: 10px;
        margin-left: 10%;
    }


    .head-bigDiv-dropdown-menu-span {
        margin-left: 5px;
    }

    .mouseoverShow {
        font-size: 18px;
    }

    #certificate {
        color: #1961AC;
        border-bottom: #1961AC 1px solid;
    }

    .certificateLi:hover {
        font-size: 17px;
        color: #1961AC;
    }

    .slideDiv {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .slideImg {
        cursor: pointer;
        transition: all 0.6s;
    }

    .slideImg:hover {
        transform: scale(1.2);
    }

    .engineeringCaseDiv {
        height: 40px;
        margin-top: -40px;
        line-height: 40px;
        background: black;
        opacity: 0.7;
        color: white;
        width: 90%;
        margin-left: 5%;
        text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap; /*让文字不换行*/
        overflow: hidden;
        font-size: 18px;
    }

    .engineeringCaseCol:hover .engineeringCaseDiv {
        background: rgb(0, 100, 185);
    }

    .culture-top {
        width: 90%;
        height: 200px;
        margin-left: 5%;
        margin-top: 20px;
    }

    .culture-bottom {
        width: 90%;
        height: 200px;
        margin-top: 20px;
        margin-left: 5%;
    }

    .culture-left {
        width: 100%;
        height: 200px;
        background: rgb(232, 239, 247);
        border-top-left-radius: 20px;
    }

    .culture-left div {
        float: left;
        width: 80%;
        margin-top: 20px;
        margin-left: 10%;
    }

    .culture-right {
        width: 100%;
        height: 200px;
        background: rgb(232, 239, 247);
        border-bottom-right-radius: 20px;
    }

    .culture-right div {
        float: left;
        width: 80%;
        margin-top: 20px;
        margin-left: 10%;
    }

    .culture:hover .culture-right {
        background: rgb(25, 97, 172);
        color: white;
    }

    .culture:hover .culture-left {
        background: rgb(25, 97, 172);
        color: white;
    }

    .culture-arrow2 {
        display: none;
    }

    .culture:hover .culture-arrow1 {
        display: none;
    }

    .culture:hover .culture-arrow2 {
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/Index.vue